/* eslint no-await-in-loop: 0 no-restricted-syntax: 0 */
import React, { useEffect, useState } from 'react';

import { useMutation } from 'react-apollo';
import { useHistory, useLocation } from 'react-router-dom';

import * as actions from 'actions';
import Loader from 'Components-redesign/Loader';
import { useI18n } from 'Hooks';
import store from 'store';

import { ACTIVATE_TEMP_USER_MUTATION } from './queries';
import { LoaderWrapper } from './styles';

const ActivateUser = () => {
  const params = useLocation();
  const token = params['search'].split('=')[1];
  const [isLoading, setLoading] = useState(true);
  const [registerTemporaryActivate] = useMutation(ACTIVATE_TEMP_USER_MUTATION);
  const history = useHistory();
  const { t } = useI18n();

  const performActivation = async () => {
    const results = await registerTemporaryActivate({
      variables: { token },
    });

    const useToken = results.data.registerTemporaryActivate.token;

    if (useToken) {
      store.dispatch(actions.setToken(useToken));

      setLoading(false);
      history.push('/onboarding-beta');
      window.location.reload();
      return;
    }
  };

  useEffect(() => {
    if (token) {
      performActivation();
    }
  }, [token]);

  return (
    <>
      {isLoading && (
        <LoaderWrapper>
          <Loader text={t('General.ActivateUser')} />
        </LoaderWrapper>
      )}
    </>
  );
};

export default ActivateUser;
